module.exports = __webpack_public_path__ + "media/invite/clone-7667fb21.svg";